import { useEffect, useState } from "react";

import { draftFromState, errorMessageOf, fetchCampaignPanel } from "./api";
import { CampaignDraft, CampaignPanelState } from "./types";

/** Carrega o painel do app Campanhas do template; o rascunho vive no template, para o Salvar levar tudo. */
export function useCampaignPanel(workspaceId: string, templateId: string, enabled: boolean) {
  const [state, setState] = useState<CampaignPanelState | null>(null);
  const [draft, setDraft] = useState<CampaignDraft>({});
  const [error, setError] = useState<string | null>(null);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    // Troca de contrato, template ou habilitação: nada do carregamento anterior sobrevive (erro velho incluído).
    setState(null);
    setError(null);
    if (!enabled || !workspaceId) return;
    let alive = true;
    fetchCampaignPanel(workspaceId, templateId)
      .then((loaded) => {
        if (!alive) return;
        setState(loaded);
        setDraft(draftFromState(loaded));
      })
      .catch((e) => alive && setError(errorMessageOf(e, "Não conseguimos carregar as campanhas deste contrato.")));
    return () => {
      alive = false;
    };
  }, [workspaceId, templateId, enabled, attempt]);

  return { state, setState, draft, setDraft, error, reload: () => setAttempt((n) => n + 1) };
}
